import { useEffect } from 'react';
import { useGroupsContext } from '../stores/groups-context';

function useGroupsLoading(): void {
  const { fetchData } = useGroupsContext();

  useEffect(() => {
    fetchData();
  }, [fetchData]);
}

export default useGroupsLoading;
